import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lodashCompact from 'lodash/compact';
import lodashKeyBy from 'lodash/keyBy';
import { Formik } from 'formik';

import {
  getTourFailureReasonLabel,
} from 'common/tourHelpers';
import renterTourListingQuestionsOptionItems, {
  questionOptionItemsToDefaultToPlaceholder,
} from 'common/userQuestionOptionItems';
import {
  USER_QUESTION_STATUS_ANSWERED,
} from 'common/userQuestionConstants';

import SrAdminCardCollapsableRow from 'client/components/SrAdminCardCollapsableRow';
import SrFormikField from 'client/components/SrFormikField';

import AdminActions from 'client/actions/Admin';

class SrAdminTourCardTourReportRow extends Component {

  static propTypes = {
    tour: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    reloadDataTableTour: PropTypes.func.isRequired,
  }

  _onQuestionStatusChange = (statusUpdate, userQuestionId, tourId) => {
    const {
      dispatch,
      reloadDataTableTour,
    } = this.props;
    dispatch(AdminActions.applyUserQuestionStatusChange, {
      userQuestionId,
      questionStatus: statusUpdate,
    }).then(() => {
      reloadDataTableTour({
        tourIdToLoad: tourId,
      });
    });
  }

  render() {
    const {
      tour,
    } = this.props;

    const tourListingsById = lodashKeyBy(tour.listings, 'id');
    const agentCommentsByShowing = tour.showings.filter((showing) => showing.agentComment);
    const negativeRenterCommentByShowing = tour.showings.filter((showing) => showing.negativeRenterComment);

    return (
      <SrAdminCardCollapsableRow
        title='Tour Report'
      >
        <div className='SrAdminTourCardTourReportRow'>
          {tour.showings.map((showing) => {
            const listing = tourListingsById[showing.listingId];
            let failureReason = showing.failureReasonAgentProvided
              ? showing.failureReasonAgentProvided
              : getTourFailureReasonLabel(showing.failureReason);
            failureReason = lodashCompact(failureReason);
            return (
              <div key={`tr-lc-${showing.tourId}${showing.listingId}`} className='listContainer'>
                <span className='listingStreetDisplay text'>
                  {showing.failureReason ? 'FAILED: ' : ''}
                  {listing.addressStreetDisplay}
                </span>
                {showing.failureReason && (
                  <div className='questions text'>
                    <ul>
                      <li><span className='text'>{failureReason}</span></li>
                    </ul>
                  </div>
                )}
              </div>
            );
          })}
          <br />
          <br />
          <div className='questionsContainer'>
            <div>
              <span className='subTitle'>Questions</span>
              {tour.showings.map((showing) => {
                const listing = tourListingsById[showing.listingId];
                const showingRenterQuestions = showing.renterQuestions;
                return (
                  <div key={`q-lc-${showing.tourId}${showing.listingId}`} className='listContainer'>
                    <span className='listingStreetDisplay text'>
                      {listing.addressStreetDisplay}{ listing.mlsNumber ? ` (MLS ${listing.mlsNumber})` : '' }
                    </span>
                    {showingRenterQuestions && showingRenterQuestions.length > 0 && (
                      <div className='questions text'>
                        <ol>
                          {showingRenterQuestions.map((questionInstance) => {
                            return (
                              <li key={questionInstance.userQuestionId}>
                                <span className='text'>{questionInstance.question}</span>
                                <Formik
                                  initialValues={{
                                    questionStatus: questionOptionItemsToDefaultToPlaceholder
                                      .includes(questionInstance.status)
                                      ? ''
                                      : questionInstance.status,
                                  }}
                                  render={(formikBag) => {
                                    return (
                                      <SrFormikField
                                        formField={{
                                          id: 'questionStatus',
                                          type: 'select',
                                          properties: {
                                            placeholder: 'Choose status...',
                                            className: questionInstance.status === USER_QUESTION_STATUS_ANSWERED // eslint-disable-line max-len
                                              ? 'questionStatusSelect markout'
                                              : 'questionStatusSelect',
                                            choices: renterTourListingQuestionsOptionItems,
                                            onChange: (event) => {
                                              const statusUpdate = event.target.value;
                                              formikBag.setFieldValue(
                                                'questionStatus',
                                                statusUpdate,
                                              );
                                              this._onQuestionStatusChange(
                                                statusUpdate,
                                                questionInstance.userQuestionId,
                                                tour.id
                                              );
                                            },
                                          },
                                          validations: ['required'],
                                        }}
                                        formikBag={formikBag}
                                      />
                                    );
                                  }}
                                />
                              </li>
                            );
                          })}
                        </ol>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div>
              <div>
                <span className='subTitle'>Renter's positive property feedback:</span>
                {agentCommentsByShowing.map((showing) => {
                  const listing = tourListingsById[showing.listingId];
                  return (
                    <div key={`q-lc-${showing.tourId}${showing.listingId}`} className='listContainer'>
                      <span className='listingStreetDisplay text'>
                        {listing.addressStreetDisplay}
                        { listing.mlsNumber ? ` (MLS ${listing.mlsNumber})` : '' }
                      </span>
                      <div className='questions text'>
                        <ul>
                          <li><span className='text'>{showing.agentComment}</span></li>
                        </ul>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div>
                <span className='subTitle'>Renter's negative property feedback:</span>
                {negativeRenterCommentByShowing.map((showing) => {
                  const listing = tourListingsById[showing.listingId];
                  return (
                    <div key={`q-lc-${showing.tourId}${showing.listingId}`} className='listContainer'>
                      <span className='listingStreetDisplay text'>
                        {listing.addressStreetDisplay}
                        { listing.mlsNumber ? ` (MLS ${listing.mlsNumber})` : '' }
                      </span>
                      <div className='questions text'>
                        <ul>
                          <li><span className='text'>{showing.negativeRenterComment}</span></li>
                        </ul>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <br />
          <br />
          <div>
            <span className='subTitle'>Notes</span>
            <span className='text'>{tour.notes}</span>
          </div>
        </div>
      </SrAdminCardCollapsableRow>
    );
  }
}

SrAdminTourCardTourReportRow.displayName = 'SrAdminTourCardTourReportRow';

export default SrAdminTourCardTourReportRow;
